import React, { useState } from 'react';
import Button from 'reactstrap/lib/Button';
import style from './CustomButtons.style.js';
import { Popover, PopoverBody, PopoverHeader, UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-regular-svg-icons';
import AttachmentsPopover from '../AdminLanding/AdminCommunications/AdminSendMessage/AdminMessageComposer/AttachmentPopover/AttachmentsPopover.js';

import './CustomButtons.style.css';
import { popoverModifiers } from 'enums.js';
const CustomOption = ({ html, onInsertAttachment, onInsertText, toggleAttachmentPopup }) => {
  const [showAttachmentPopover, setShowAttachmentPopover] = useState(false);
  const [attachmentsCount, setAttachmentsCount] = useState(0);
  const [uniqueAttachmentsInTemplate, setUniqueAttachmentsInTemplate] = useState(0);

  const handleButtonMouseDown = (event) => {
    event.preventDefault();
  };

  const addStar = () => {
    onInsertText?.('{FirstName}');
  };

  const addLastName = () => {
    onInsertText?.('{LastName}');
  };

  const addButton = (buttonText) => {
    onInsertText?.(buttonText);
  };

  const addScheduleInterviewButton = () => {
    addButton('{RegistrationInvitationButton}');
  };

  const addViewScheduleButton = () => {
    addButton('{ViewScheduleButton}');
  };

  const addPhotoUploadButton = () => {
    addButton('{PhotoUploadButton}');
  };

  const addCandidateEventButton = () => {
    addButton('{CandidateEventButton}');
  };

  const addWaitListDate = () => {
    onInsertText?.('{WaitlistInfo}');
  };

  const addInterviewDate = () => {
    onInsertText?.('{InterviewDate}');
  };

  const addAttachment = (attachment) => {
    const { DisplayName, DocumentUUID } = attachment || {};
    const { REACT_APP_BUILD_TYPE } = process.env;
    const server = REACT_APP_BUILD_TYPE === 'liveproduction'
      ? 'https://app.rezrate.com/department/attachment'
      : 'https://dev.rezrate.com/department/attachment';

    onInsertAttachment?.({ text: `Attachment: ${DisplayName}  `, url: `${server}/${DocumentUUID}` });
  };

  const renderAttachmentsPopover = () => {
    // return;
    return (
      <Popover
        placementPrefix="attachmentsPopover bs-popover"
        modifiers={popoverModifiers}
        isOpen={showAttachmentPopover}
        placement="top"
        trigger="legacy"
        target="attachment_button"
        toggle={(e) => {
          if (e.target.className.includes && e.target.className.includes('swal2')) {
            return;
          }
          const newAttachmentPopover = document.getElementById('newAttachmentPopover_comms_composer');
          const editPopovers = document.getElementsByClassName('editAttachmentPopover_');
          const eventTarget = e.target;

          if (
            eventTarget &&
            newAttachmentPopover &&
            // eventTarget.id != attachmentButton.id &&
            newAttachmentPopover.contains(eventTarget)
          ) {
            return;
          }

          if (eventTarget) {
            let isFromEditPopover = false;
            let counter = 0;
            while (counter < editPopovers.length && !isFromEditPopover) {
              if (editPopovers[counter].contains(eventTarget)) {
                isFromEditPopover = true;
              }
              counter++;
            }

            if (isFromEditPopover) {
              return;
            }
          }

          setShowAttachmentPopover((prevState) => !prevState);
        }}
      >
        <PopoverHeader>
          <div style={style.spacedBetweenRow}>
            <div style={style.buttonLabel}>{attachmentsCount} Files in Library</div>
            <div>
              <FontAwesomeIcon
                icon={faTimesCircle}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setShowAttachmentPopover(false);
                  // setTemplateToEdit(null);
                }}
              />
            </div>
          </div>
        </PopoverHeader>
        <PopoverBody>
          <AttachmentsPopover
            uniqueId="comms_composer"
            addAttachment={addAttachment}
            setAttachmentsCount={setAttachmentsCount}
            html={html}
            setUniqueAttachmentsInTemplate={setUniqueAttachmentsInTemplate}
          />
        </PopoverBody>
      </Popover>
    );
  };

  return (
    <div style={style.actionButtonContainer} id="custom-button-wrapper">
      <Button
        style={style.actionButton('First Name')}
        size="sm"
        color="info"
        onMouseDown={handleButtonMouseDown}
        onClick={(e) => {
          e.preventDefault();
          addStar();
        }}
      >
        First Name
      </Button>
      <Button
        style={style.actionButton('Last Name')}
        size="sm"
        color="info"
        onMouseDown={handleButtonMouseDown}
        onClick={(e) => {
          e.preventDefault();
          addLastName();
        }}
      >
        Last Name
      </Button>
      <Button
        style={style.actionButton('Registration Invitation')}
        size="sm"
        color="info"
        onMouseDown={handleButtonMouseDown}
        onClick={(e) => {
          e.preventDefault();
          addScheduleInterviewButton();
        }}
      >
        Registration Invitation
      </Button>
      <Button
        style={style.actionButton('View Schedule Button')}
        size="sm"
        color="info"
        onMouseDown={handleButtonMouseDown}
        onClick={(e) => {
          e.preventDefault();
          addViewScheduleButton();
        }}
      >
        View Schedule Button
      </Button>
      <Button
        style={style.actionButton('Waitlist Date')}
        size="sm"
        color="info"
        onMouseDown={handleButtonMouseDown}
        onClick={(e) => {
          e.preventDefault();
          addWaitListDate();
        }}
      >
        Waitlist Info
      </Button>
      <Button
        style={style.actionButton('Interview Date')}
        size="sm"
        color="info"
        onMouseDown={handleButtonMouseDown}
        onClick={(e) => {
          e.preventDefault();
          addInterviewDate();
        }}
      >
        Interview Date
      </Button>
      <Button
        style={style.actionButton('Photo Upload Button')}
        size="sm"
        color="info"
        onMouseDown={handleButtonMouseDown}
        onClick={(e) => {
          e.preventDefault();
          addPhotoUploadButton();
        }}
      >
        Photo Upload Button
      </Button>
      <Button
        style={style.actionButton('Candidate Event')}
        size="sm"
        color="info"
        onMouseDown={handleButtonMouseDown}
        onClick={(e) => {
          e.preventDefault();
          addCandidateEventButton();
        }}
      >
        Candidate Event
      </Button>
      <Button
        style={style.actionButton('Photo Upload Button')}
        size="sm"
        color="info"
        id="attachment_button"
        onClick={(e) => {
          e.preventDefault();
          toggleAttachmentPopup();
        }}
      >
        <div style={{ ...style.simpleRow }}>
          <div style={style.simpleColumn}>
            Link File ({uniqueAttachmentsInTemplate}/{attachmentsCount})
          </div>
          <div style={{ ...style.simpleColumn, alignItems: 'center', justifyContent: 'center', width: 30 }}>
            <div style={{ ...style.simpleRow, alignItems: 'center', justifyContent: 'center' }}>
              <FontAwesomeIcon icon={faFile} style={{ fontSize: 15 }} />
              <div style={{ position: 'relative' }}>
                <FontAwesomeIcon
                  icon={faLink}
                  style={{
                    // padding: 1,
                    borderRadius: 20,
                    backgroundColor: '#17a2b8',
                    position: 'absolute',
                    fontSize: 7,
                    left: -5,
                    top: 2,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {renderAttachmentsPopover()}
      </Button>
      <UncontrolledTooltip target="attachment_button" placement="top">
        The current template contains {uniqueAttachmentsInTemplate} of {attachmentsCount} available attachments.
      </UncontrolledTooltip>
    </div>
  );
};
export default CustomOption;

//Candidate First Name
//Candidate Last Name
//Registration Invitation
//View Schedule Button
// Wait List Date
//Interview Date
//Photo Upload Button
